import LoadingButton from '@mui/lab/LoadingButton';
import { Box, TextField } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { Ari } from '~/assets/icons';
import { MessageBubble } from '../Message';
import { Message } from '../types';
import { container, containerDefault, containerMessage, messageAfter } from '../UserConfirmation/styles';

/** 1 = SMS (celular), 2 = E-mail */
const CODE_DELIVERY = {
  1: 'celular',
  2: 'e-mail'
} as const;

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  questionComponent?: Message['questionComponent'];
  Component?: Message['Component'];
  userName?: string;
  onCodeSubmit?: (code: string) => void;
  onResendCode?: () => void;
  /** 1 = SMS, 2 = E-mail - define o texto "para seu celular" ou "para seu e-mail" */
  codeDeliveryChannel?: 1 | 2;
}

export const CodeVerification = ({ userName, onCodeSubmit, onResendCode, codeDeliveryChannel }: Props) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);

  const channelLabel = codeDeliveryChannel ? CODE_DELIVERY[codeDeliveryChannel] : 'e-mail';

  const handleCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setVerificationCode(event.target.value);
  };

  const handleCodeSubmit = async () => {
    if (verificationCode && onCodeSubmit) {
      setLoading(true);
      try {
        await onCodeSubmit(verificationCode.trim());
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box sx={containerDefault}>
      {/* Mensagem do bot */}
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Ari />
        <MessageBubble
          content={`${
            userName?.split(' ')[0] || 'José'
          }, enviamos um código de verificação para seu ${channelLabel}. Favor informar no campo abaixo.`}
        />
      </Box>

      {/* Campo de código de verificação */}
      <Box sx={container}>
        <Box sx={() => containerMessage()}>
          <TextField
            fullWidth
            type="text"
            value={verificationCode}
            onChange={handleCodeChange}
            placeholder="Código de verificação"
            variant="outlined"
            inputProps={{
              maxLength: 6,
              style: { textAlign: 'center', fontSize: '1.25rem' }
            }}
          />
          <Box sx={messageAfter} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', width: '100%', marginTop: '2rem', gap: '1rem' }}>
        {/* Botão para reenviar código */}
        {onResendCode && (
          <LoadingButton
            fullWidth
            size="medium"
            variant="text"
            onClick={onResendCode}
            sx={{
              marginTop: '8px',
              color: '#A547FF',
              '&:hover': {
                backgroundColor: 'rgba(165, 71, 255, 0.1)'
              }
            }}
          >
            Reenviar código
          </LoadingButton>
        )}
        {/* Botão para próximo passo */}
        <LoadingButton
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          onClick={handleCodeSubmit}
          disabled={!verificationCode || verificationCode.length < 4}
          loading={loading}
          sx={{
            marginTop: '8px',
            backgroundColor: '#A547FF',
            '&:hover': {
              backgroundColor: '#8A3CD9'
            }
          }}
        >
          Próximo passo
        </LoadingButton>
      </Box>
    </Box>
  );
};
